import { createContext, useContext } from "react";

const CreateTaskContext = createContext({});

export const CreateTaskContextProvider = CreateTaskContext.Provider;
export const CreateTaskContextConsumer = CreateTaskContext.Consumer;

export const useCreateTaskContext = () => useContext(CreateTaskContext);

export default CreateTaskContext;
